import { FC, MouseEvent, useCallback } from "react";
import { useLocalStorage } from "@/hooks/useLocalStorage";
import { donationFormatter } from "@/lib/utils";
import { useSocket } from "@/hooks/useSocket";

interface EmulateDonationButtonProps {
    id: string;
    donator?: string;
    fallbackAmount: number;
}

export const EmulateDonationButton: FC<EmulateDonationButtonProps> = ({ id, donator, fallbackAmount }) => {
    const socket = useSocket();
    const [amount, setAmount] = useLocalStorage<number>(`emulate-donation-button-${id}`, fallbackAmount);

    const handleClick = useCallback((e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();

        // Right Click
        if (e.altKey || e.ctrlKey || e.metaKey) {
            const newAmount = prompt("Enter new amount:", amount.toString());
            if (newAmount !== null) {
                const parsedAmount = Number.parseFloat(newAmount.replace(",", "."));
                if (!Number.isNaN(parsedAmount) && parsedAmount > 0) {
                    setAmount(parsedAmount);
                }           
            }
            return;
        }

        socket.emit("emulate-donation", donator ?? "Anonymous", amount, import.meta.env.VITE_DONATION_CURRENCY_SYMBOL, "streamelements");
    }, [donator, amount, setAmount, socket]);

    return (
        <button
            type="button"
            className="text-white bg-purple-700 hover:bg-purple-800 focus:ring-4 focus:outline-none focus:ring-purple-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-800"
            onClick={handleClick}
        >
            Emulate {donationFormatter.format(amount)}
        </button>
    )
}